<script>
import ListCoursesStudentComponent from '../../features/lists/ListCoursesStudentComponent';
import ModalCourseView from '../modals/ModalCourseView';
import ModalImportView from '../../../shared/views/ModalImportView';
import ModalStudentInfoView from '../../../account/views/ModalStudentInfoView';
import LiveSearchComponent from '../../../shared/features/LiveSearchComponent';

export default {
  name: 'ListCourseStudentView',
  components: {
    'modal-course-category-view': ModalCourseView,
    'modal-import': ModalImportView,
    'modal-student-info-view': ModalStudentInfoView,
  },
  extends: ListCoursesStudentComponent,
  mixins: [LiveSearchComponent],
  data() {
    return {
      // Campo por el que filtra el API el buscador de cursos
      searchField: 'Title',
      // Portadas de curso que fallaron al cargar (fichero ausente en /uploads)
      failedCovers: [],
    };
  },
  methods: {
    onCoverError(courseId) {
      if (!this.failedCovers.includes(courseId)) {
        this.failedCovers.push(courseId);
      }
    },
    hasCover(courseId) {
      return !this.failedCovers.includes(courseId);
    },
  },
};
</script>

<template>
  <div class="list-body">
    <!-- Toolbar de búsqueda y filtros estilo Appmisionate -->
    <div class="stream_toolbar">
      <div class="stream_search_box">
        <el-input
          v-model="searchName"
          type="text"
          placeholder="Buscar curso por título o palabra clave..."
          prefix-icon="Search"
          clearable
          class="stream_search_input"
          @input="onSearchInput"
          @clear="onClearSearch"
          @keyup.enter="onSearchSubmit"
        />
      </div>
      <div class="stream_toolbar_meta">
        <span
          v-if="pagination.totalItems > 0 || (collection && collection.length > 0)"
          class="stream_count_badge"
        >
          <i class="uil uil-books" />
          Mostrando <strong>{{ pagination.totalItems || collection.length }}</strong> curso(s)
        </span>
      </div>
    </div>

    <!-- Grilla de Cursos -->
    <div
      v-loading="isListLoading"
      element-loading-text="Cargando catálogo de cursos..."
      class="row dash_courses_row"
    >
      <div
        v-for="course in collection"
        :key="course.id"
        class="col-xl-3 col-lg-4 col-md-6 col-12 d-flex"
      >
        <div class="dash_course_card dash_course_card--wide mb-30">
          <router-link
            :to="'/estudiante/cursos/' + course.id + '/detalles'"
            class="dash_course_thumb"
          >
            <img
              v-if="hasCover(course.id)"
              :src="getCoverImage(course.coverImageUrl)"
              :alt="course.title"
              @error="onCoverError(course.id)"
            >
            <div
              v-else
              class="dash_course_thumb_fallback"
            >
              <i class="uil uil-book-open" />
            </div>
            <div class="dash_course_play">
              <i class="uil uil-play" />
            </div>
            <div
              v-if="course.totalHours"
              class="dash_course_duration"
            >
              <i class="uil uil-clock-three" /> {{ course.totalHours }} Horas
            </div>
          </router-link>

          <div class="dash_course_body">
            <div class="dash_course_meta">
              <span class="dash_course_views">
                <i class="uil uil-eye mr-1" /> {{ course.totalViewed || 0 }} vista(s)
              </span>
              <button
                type="button"
                class="dash_course_like_btn"
                :class="{ active: course.isLiked }"
                title="Me gusta"
                @click.prevent="onDoLike(course)"
              >
                <i :class="course.isLiked ? 'uil uil-heart active' : 'uil uil-heart'" />
              </button>
            </div>

            <router-link
              :to="'/estudiante/cursos/' + course.id + '/detalles'"
              class="dash_course_title"
              :title="course.title"
            >
              {{ course.title }}
            </router-link>

            <span
              v-if="course.tags"
              class="dash_course_tag"
            >
              {{ mapTags(course.tags) }}
            </span>

            <div class="dash_course_footer">
              <span
                v-if="course.author"
                class="dash_course_author"
              >
                Por <strong>{{ course.author }}</strong>
              </span>
              <span
                v-else
                class="dash_course_author"
              >
                Docente certificado
              </span>

              <router-link
                :to="'/estudiante/cursos/' + course.id + '/detalles'"
                class="dash_course_action"
              >
                Ver curso <i class="uil uil-arrow-right" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Estado vacío -->
    <div
      v-if="isCollectionEmpty(collection) && !isListLoading"
      class="stream_empty_state"
    >
      <div class="stream_empty_icon">
        <i class="uil uil-book-open" />
      </div>
      <h3 class="stream_empty_title">
        No se encontraron cursos
      </h3>
      <p class="stream_empty_text">
        {{ searchName ? `No encontramos cursos que coincidan con "${searchName}".` : 'No hay cursos disponibles en este momento.' }}
      </p>
      <el-button
        v-if="searchName"
        type="primary"
        size="small"
        class="mt-3"
        @click="onClearSearch"
      >
        Limpiar búsqueda
      </el-button>
    </div>

    <!-- Paginación unificada -->
    <div
      v-if="!isCollectionEmpty(collection) && pagination.totalPages > 1"
      class="courses_pagination_wrapper"
    >
      <el-pagination
        v-model:current-page="currentPage"
        background
        layout="prev, pager, next"
        :page-count="pagination.totalPages"
        @current-change="onPageChange"
      />
    </div>

    <!-- Modales -->
    <modal-course-category-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
    />
    <modal-student-info-view
      v-if="modalSubscriptionInfo.isVisible"
      :form-data="studentInfoItem"
      :conf="modalSubscriptionInfo"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>
